import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

// REQUESTS
import useSettingsRequest from '../../../requests/SettingsRequest';

const MfaChoiceDialog = ({ option, show, onChange, errorHandler }) => {
  const { associateMfa } = useSettingsRequest();

  const [mfaOption, setMfaOption] = useState('Disabled');
  const [showDialog, setShowDialog] = useState(false);
  const [newMfaLoading, setNewMfaLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setShowDialog(true);
    }
  }, [show]);

  useEffect(() => {
    setMfaOption(option);
  }, [option]);

  const hide = (e) => {
    e.stopPropagation();

    setShowDialog(false);
    onChange();
  };

  const enableMfa = async () => {
    setNewMfaLoading(true);

    const response = await associateMfa(mfaOption, errorHandler);

    setShowDialog(false);
    setNewMfaLoading(false);
    onChange(mfaOption, response.code);
  };

  return (
    <Dialog open={showDialog} onClose={hide}>
      <DialogTitle>Setup Multi-Factor Authentication</DialogTitle>
      <DialogContent>
        <Stack>
          <Typography>Which method would you like to use?</Typography>

          <RadioGroup
            value={mfaOption}
            onChange={(e) => setMfaOption(e.target.value)}
            sx={{ marginLeft: { xl: 4 } }}
          >
            <FormControlLabel
              value="S"
              control={<Radio sx={{ paddingY: 0 }} color="secondary" />}
              label="SMS"
            />
            <FormControlLabel
              value="E"
              control={<Radio sx={{ paddingY: 0 }} color="secondary" />}
              label="Email"
            />
            <FormControlLabel
              value="A"
              control={<Radio sx={{ paddingY: 0 }} color="secondary" />}
              label="Authenticator App"
            />
          </RadioGroup>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="text"
          onClick={hide}
          sx={{
            textTransform: 'none',
            textDecoration: 'underline',
            fontWeight: 400,
          }}
        >
          Cancel
        </Button>
        <Button
          color="secondary"
          variant="contained"
          disabled={newMfaLoading}
          onClick={enableMfa}
        >
          {newMfaLoading ? 'Saving ...' : 'Next'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MfaChoiceDialog;
